import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/tailwind-component/ui/dialog";
import { X } from "lucide-react";

interface Props {
  open: boolean;
  title?: string;
  children: React.ReactNode;
  onClose: () => void;
}

const CommonModalClosable: React.FC<Props> = ({
  open,
  title,
  children,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <DialogContent
        className="
            fixed
            left-1/2
            top-1/2
            -translate-x-1/2
            -translate-y-1/2
            sm:max-w-lg
            w-[90%]
            max-w-[420px]
        "
         style={{transform:'inherit'}}
        >
        {/* Close icon */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 opacity-70 hover:opacity-100 transition"
        >
          <X className="w-4 h-4" />
        </button>

        {title && (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
        )}

        <div className="mt-2 mb-2 fs-14">
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CommonModalClosable;